import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import TasksPage from './TasksPage';
import FriendsPage from './FriendsPage';
import BottomNav from './BottomNav';
import Welcome from './Welcome';
import NoDataNotice from './NoDataNotice';
import { AppProvider, useAppContext } from './AppContext';

const App: React.FC = () => {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
};

const AppContent: React.FC = () => {
  const { loginData, dataIsReady } = useAppContext();

  if (!dataIsReady) {
    return <div className='h-screen flex-1 flex items-center justify-center'>
      <p className='page-header italic text-gray-600'>Loading...</p>
    </div> ;
  }

  if (!loginData) {
    return <NoDataNotice />;
  }

  return <>
    <Welcome />
    <MainApp />
  </>;
};

const MainApp: React.FC = () => {
  return (
    <Router>
      <div className="h-screen flex flex-col bg-gray-100 text-black">
        <div className="flex-1 overflow-auto">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/tasks" element={<TasksPage />} />
            <Route path="/friends" element={<FriendsPage />} />
          </Routes>
        </div>
        <div className="w-full h-24 bg-gray-100">
          <BottomNav />
        </div>
      </div>
    </Router>
  );
};

export default App;